import React from "react";
import { useTranslation } from "react-i18next";

import { config } from "links/lib/constants";

import { SubmarkLogoPearPracticeSVG } from "./resource/SubmarkLogoPearPracticeSVG";
import { SubmarkLogoSVG } from "./resource/SubmarkLogoSVG";

export interface IProps {
  fillColor?: string;
}

const SubmarkLogo: React.FC<IProps> = ({ fillColor = "#000000" }) => {
  const { t } = useTranslation("admin", { useSuspense: false });

  return (
    <>
      {config.usePearPracticeBranding ? (
        <SubmarkLogoPearPracticeSVG aria-label={t("logo.ariaLabel")} />
      ) : (
        <SubmarkLogoSVG
          fillColor={fillColor}
          aria-label={t("logo.ariaLabel")}
        />
      )}
    </>
  );
};

export { SubmarkLogo };
